<template>
  <div>
    <div class="row bg-white p-10">
      <div
        class="col-xl-4 col-lg-12 justify-content-start d-flex align-items-center soha-align-center soha-mb-1"
      >
        <span class="svg-icon-secondary mr-3">
          <inline-svg src="/media/svg/soha/icons/add-user.svg" />
        </span>
        <h2 class="card-label mb-0 soha-page-title">
          {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
        </h2>
      </div>
      <div
        class="col-xl-8 col-lg-12 d-flex justify-content-end flex-wrap soha-align-center"
        v-if="access"
      >
        <router-link
          class="soha-mb-1-mob"
          :to="{ name: 'recruitment-request-create' }"
        >
          <soha-button
            v-if="canDo.includes('createRecruitmentRequest')"
            name="addRecruitmentRequest"
            :text="$t(`${I18nPrefix}BTN_TITLE`)"
            icon="plus"
            class="mx-3"
            width=""
          ></soha-button>
        </router-link>
        <soha-order-selection
          :title="$t(`${I18nPrefix}ORDER_BY_TXT`)"
          :options="orderSelectionOptions"
          @change="indexRecruitmentRequests(true)"
          v-model="status"
        />
      </div>
      <soha-page-loading class="col-lg-12"  v-if="loading" />
      <div v-else class="col-lg-12 pt-5">
        <soha-no-access
          v-if="!access"
          :message="$t(`${I18nPrefix}ACCESS_MESSAGE`)"
        />
        <soha-recruitment-request-table
          v-else
          :recruitmentRequests="recruitmentRequests"
          :fullName="userFullName"
          :image="userImage"
          :post="userPost"
          :genderId="userGender"
        />
        <b-pagination
          class="pt-5"
          v-if="totalRecruitmentCount > perPage"
          align="center"
          pills
          @input="goToPage"
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="totalRecruitmentCount"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import sohaRecruitmentRequestTable from "@/view/components/recruitment-request/RecruitmentRequestTable";

export default {
  name: "RecruitmentRequestUserIndex",
  components: { sohaRecruitmentRequestTable },
  data() {
    return {
      I18nPrefix: "PAGES.RECRUITMENT_REQUEST.INDEX.",
      orderSelectionOptions: [
        {
          id: null,
          title: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.ALL_ITEMS`),
        },
        {
          id: 1,
          title: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.WAITING_ITEMS`),
        },
        {
          id: 2,
          title: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.CONFIRM_ITEMS`),
        },
        {
          id: 3,
          title: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.REJECT_ITEMS`),
        },
        {
          id: 4,
          title: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.DELAY_ITEMS`),
        },
        {
          id: 5,
          title: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.PUBLISH_ITEMS`),
        },
        {
          id: 6,
          title: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.CANCEL_ITEMS`),
        },
      ],
      recruitmentRequests: [],
      status: null,
      loading: true,
      access: false,
      currentPage: 1,
      perPage: null,
      totalRecruitmentCount: null,
    };
  },
  mounted() {
    this.currentPage = this.$route.query.page ? +this.$route.query.page : 1;
    this.indexRecruitmentRequests();
  },
  computed: {
    ...mapGetters([
      "canDo",
      "userId",
      "userFullName",
      "userImage",
      "userPost",
      "userGender",
    ]),
  },
  methods: {
    indexRecruitmentRequests(param) {
      if (param) {
        this.currentPage = 1;
        this.$router.push({ query: { page: this.currentPage } });
      }
      this.loading = true;
      let url = "api/v2/users/" + this.userId + "/recruitment-requests";
      ApiService.get(url, {
        status: this.status,
        page: this.currentPage,
      }).then(({ data }) => {
        if (!data.code) {
          this.access = true;
          this.recruitmentRequests = data.data;
          this.perPage = data.per_page;
          this.totalRecruitmentCount = data.total;
        } else if (+data.code === 403) {
          this.access = false;
        } else if (+data.code === 500) {
          this.errorToast(data.message);
        }
        this.loading = false;
      });
    },
    goToPage() {
      this.$router.push({ query: { page: this.currentPage } });
      this.indexRecruitmentRequests();
    },
  },
};
</script>
